<template>
  <v-card :loading="isLoading">
    <v-data-table
      :items="triggers"
      :headers="headers"
      :loading="isLoading"
      item-key="id"
      class="elevation-1"
    >
      <template #body.prepend>
        <trigger-editor
          v-if="isAddingNewItem"
          :bots="bots"
          :trigger="getEmptyTrigger()"
          :trigger-types="triggerTypes"
          @close="isAddingNewItem = false"
          @save="$emit('upsert-trigger', $event)"
        />
      </template>
      <template #header.actions>
        <v-btn
          color="primary"
          icon
          @click="isAddingNewItem = true"
        >
          <v-icon>
            mdi-plus
          </v-icon>
        </v-btn>

        <v-btn
          class="ml-auto"
          color="primary"
          icon
          @click="isConfigOpen = true"
        >
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </template>

      <template #item="{ item }">
        <trigger-editor
          v-if="editingId === item.communication_bot_trigger_id"
          :trigger="item"
          :bots="bots"
          :is-loading="isLoading"
          :trigger-types="triggerTypes"
          @close="editingId = null"
          @save="$emit('upsert-trigger', $event)"
        />
        <trigger-view
          v-else
          :bot-name-by-id="botNameById"
          v-bind="item"
          @send-test-message="$emit('send-test-message', item)"
          @edit="editingId = item.communication_bot_trigger_id"
          @delete="$emit('delete-trigger', { communication_bot_trigger_id: item.communication_bot_trigger_id })"
        />
      </template>
    </v-data-table>

    <v-dialog
      v-model="isConfigOpen"
      max-width="1200px"
    >
      <v-card>
        <v-card-title>
          Edit Communication Bots Config
        </v-card-title>

        <v-card-text>
          <vue-json-editor
            v-model="config"
            mode="code"
            :modes="[]"
            :show-btns="false"
            expanded-on-start
          />
        </v-card-text>

        <v-card-actions class="d-flex justify-end">
          <v-btn
            color="error"
            @click="isConfigOpen = false"
          >
            Cancel
          </v-btn>

          <v-btn
            color="success"
            @click="$emit('update-config', { config })"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { cloneDeep } from 'lodash'
import TriggerEditor from './TriggerEditor.vue'
import TriggerView from './TriggerView.vue'
import vueJsonEditor from 'vue-json-editor'

export default {
  components: {
    TriggerEditor,
    TriggerView,
    vueJsonEditor,
  },
  props: {
    isLoading: Boolean,
    bots: {
      type: Array,
      required: true,
    },
    triggerTypes: {
      type: Array,
      required: true,
    },
    triggers: {
      type: Array,
      required: true,
    },
    rawConfig: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editingId: null,
      isAddingNewItem: false,

      headers: [
        { text: 'Bot', value: 'bot_id' },
        { text: 'Project', value: 'entity_id' },
        { text: 'Type', value: 'type' },
        { text: 'Chat ID', value: 'chat_id' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],

      isConfigOpen: false,
      config: this.rawConfig,
    }
  },

  computed: {
    botNameById() {
      const botNameById = {}
      for (const bot of this.bots) {
        botNameById[bot.id] = bot.name
      }
      return botNameById
    }
  },

  methods: {
    getEmptyTrigger() {
      return {
        bot_id: null,
        entity_id: null,
        type: null,
        chat_id: '',
      }
    },
  },

  watch: {
    isLoading(yes) {
      if (!yes) {
        this.isAddingNewItem = false
        this.editingId = null
        this.isConfigOpen = false
      }
    },

    isConfigOpen(yes) {
      if (yes) {
        this.config = cloneDeep(this.rawConfig)
      }
    }
  }
}
</script>
